var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link__logout"},[_c('router-link',{attrs:{"to":"logout"}},[_vm._v("Log out")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }